import { AxiosInstance } from "axios";
import { IEventSession } from "../interfaces/IEventSession";

export class EventSessionService {
    private apiClient: AxiosInstance;
    private endpoint: string;
    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
        this.endpoint = '/admin/event-day-session';
    }

    async getAll(dayId: string): Promise<IEventSession[]> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${dayId}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }

    async get(dayId: string, id: string): Promise<IEventSession> {
        try {
            const response = await this.apiClient.get(`${this.endpoint}/${dayId}/${id}`);
            return response.data;
        } catch (error: any) {
            throw new Error(error.response ? error.response.data : 'An error occurred');
        }
    }
}